import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`

/*! minireset.css v0.0.6 | MIT License | github.com/jgthms/minireset.css */
html,
body,
p,
ol,
ul,
li,
dl,
dt,
dd,
blockquote,
figure,
fieldset,
legend,
textarea,
pre,
iframe,
hr,
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
  font-family: ${({ theme }) => theme.fntSans};
  font-weight: 400;
  /* color: ${({ theme }) => theme.black}; */
  /* line-height: 1.25; */
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: normal;
}

ul {
  list-style: none;
}

button,
input,
select {
  margin: 0;
}

html {
  box-sizing: border-box;
}

*, *::before, *::after {
  box-sizing: inherit;
}

img,
video {
  height: auto;
  max-width: 100%;
}

iframe {
  border: 0;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
}

td,
th {
  padding: 0;
}

a {
  color: ${({ theme }) => theme.primaryColor};
}

a:hover {
  color: ${({ theme }) => theme.black};
}

`;

export default GlobalStyles;
